import type { z } from 'zod';
import {
  FriendimizerDataResponseSchema,
  FriendimizerImpactResponseSchema,
  FriendimizerStatsResponseSchema,
} from '../arena';

export type FriendimizerDataResponseInput = z.input<typeof FriendimizerDataResponseSchema>;
export type FriendimizerDataResponseOutput = z.output<typeof FriendimizerDataResponseSchema>;

export function serializeFriendimizerDataResponse(
  payload: FriendimizerDataResponseInput
): FriendimizerDataResponseOutput {
  return FriendimizerDataResponseSchema.parse(payload);
}

export type FriendimizerStatsResponseInput = z.input<typeof FriendimizerStatsResponseSchema>;
export type FriendimizerStatsResponseOutput = z.output<typeof FriendimizerStatsResponseSchema>;

export function serializeFriendimizerStatsResponse(
  payload: FriendimizerStatsResponseInput
): FriendimizerStatsResponseOutput {
  return FriendimizerStatsResponseSchema.parse(payload);
}

export type FriendimizerImpactResponseInput = z.input<typeof FriendimizerImpactResponseSchema>;
export type FriendimizerImpactResponseOutput = z.output<typeof FriendimizerImpactResponseSchema>;

export function serializeFriendimizerImpactResponse(
  payload: FriendimizerImpactResponseInput
): FriendimizerImpactResponseOutput {
  return FriendimizerImpactResponseSchema.parse(payload);
}
